import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    unpauseModalContent: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: '32px',
      width: '100%',
    },
    unpauseSuccessContent: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      // gap: '32px',
      width: '100%',
    },
    unpauseSuccessContentInner: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '26px',
      width: '100%',
    },
    detailsContainer: {
      border: `1px solid ${theme.colors.shark}`,
      borderRadius: '24px',
      padding: '12px 24px 24px 24px',
      width: '100%',
    },
    title: {
      fontSize: '40px',
      lineHeight: '40px',
    },
    venueName: {
      fontSize: '22px',
      fontWeight: theme.fontWeights.medium,
    },
    text: {},
    table: {
      padding: '20px 0',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '16px',
    },
    tableLabel: {
      color: theme.colors.smoke,
    },
    pointsContainer: {
      // padding: '12px 24px 24px 24px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
  }),
  { name: 'UnpauseModal' },
);

export default useStyles;
